module.exports = function () {
  (function () {
    // Проверяем, поддерживается ли MutationObserver
    if (!window.MutationObserver) return;

    // Оригинальный метод для добавления событий
    var originalAddEventListener = EventTarget.prototype.addEventListener;

    EventTarget.prototype.addEventListener = function (type, listener, options) {
      if (type === 'DOMNodeInserted') {
        // Используем MutationObserver для эмуляции события DOMNodeInserted
        var targetNode = this;

        // Функция, которую передаем в MutationObserver
        var observerCallback = function (mutationsList) {
          mutationsList.forEach(function (mutation) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
              mutation.addedNodes.forEach(function (node) {
                if (node.nodeType === 1) { // Проверяем, что это элемент
                  listener.call(node, new Event('DOMNodeInserted'));
                }
              });
            }
          });
        };

        // Создаем новый MutationObserver
        var observer = new MutationObserver(observerCallback);

        // Начинаем наблюдение
        observer.observe(targetNode, { childList: true, subtree: true });
      } else {
        // Для всех остальных событий используем стандартный addEventListener
        originalAddEventListener.call(this, type, listener, options);
      }
    };
  })();
};



/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/js/polyfills.js
 **/